import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import bn from './locales/bn/translation.json';
import hi from './locales/hi/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';

const savedLng = (typeof window !== 'undefined' && localStorage.getItem('appLng')) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      bn: { translation: bn },
      hi: { translation: hi },
      de: { translation: de },
      es: { translation: es }
    },
    lng: savedLng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;
